import { render, staticRenderFns } from "./BfDateInput.vue?vue&type=template&id=621a77ba&"
import script from "./BfDateInput.vue?vue&type=script&lang=js&"
export * from "./BfDateInput.vue?vue&type=script&lang=js&"
import style0 from "./BfDateInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports